export default __webpack_public_path__ + "static/media/stats_views.b8db3f2d.svg";